<template>
  <div class="f-p">
    <div class="f-p-data">
      <fm-table
        :column-list="columnList"
        :data-list="[{}].concat(dataList)"
        @tableAction="tableAction"
        :table-actions="tableActions">
      </fm-table>
    </div>
    <fm-form-dialog
      form-title="条件"
      :open-dialog.sync="openDialog"
      :form-parms="formParms"
      :old-data="chooseData"
      label-alone
      label-align="left"
      form-width="800px"
      @formSubmit="formSubmit"
      @handleClose="handleClose">
    </fm-form-dialog>
  </div>
</template>

<script>
let dcopy = require('deep-copy')

export default {
  name: 'conditions',
  props: {
    value: Array,
    isJoin: Boolean
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value: {
      handler () {
        this.dataList = dcopy(this.value)
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    columnList () {
      let data = [{
        title: '表名或别名',
        field: 'table'
      },
      {
        title: '列名',
        field: 'column'
      },
      {
        title: '计算符',
        field: 'compOpe'
      },
      {
        title: '值',
        field: 'value'
      },
      {
        title: '其他表或别名',
        field: 'comparedTable'
      },
      {
        title: '其他列名',
        field: 'comparedColumn'
      }]
      return this.isJoin ? data.slice(1) : data
    },
    formParms () {
      let data = [{
        type: 'input',
        label: '表名或别名',
        key: 'table',
        check: {
          required: true
        }
      },
      {
        type: 'input',
        label: '列名',
        key: 'column',
        check: {
          required: true
        }
      },
      {
        type: 'select',
        label: '计算符',
        key: 'compOpe',
        selectDatas: ['=', '>', '<', '>=', '<=', 'in', 'is null', 'is not null', '!='].map((v) => {
          return {
            key: v,
            label: v
          }
        })
      },
      {
        type: 'input',
        label: '值',
        key: 'value'
      },
      {
        type: 'input',
        label: '其他表或别名',
        key: 'comparedTable'
      },
      {
        type: 'input',
        label: '其他列名',
        key: 'comparedColumn'
      }]
      return this.isJoin ? data.slice(1) : data
    }
  },
  data () {
    return {
      isNew: false,
      chooseData: null,
      tableActions: [{
        key: 'add',
        label: '新增',
        show: (data) => {
          return !data.column
        }
      },
      {
        key: 'del',
        label: '删除',
        show: (data) => {
          return data.column
        }
      }],
      dataList: [],
      openDialog: false
    }
  },
  methods: {
    tableAction (parm) {
      if (parm.action === 'add') {
        this.isNew = true
        this.chooseData = null
        this.openDialog = true
      } else if (parm.action === 'del') {
        this.chooseData = parm.data
        this.dataList = this.dataList.filter(v => v.column !== this.chooseData.column)
        this.$emit('change', this.dataList.map((v) => {
          let a = {}
          Object.keys(v).forEach((v2) => {
            a[v2] = v[v2]
          })
          return a
        }))
      }
    },
    handleClose () {
      this.openDialog = false
    },
    formSubmit (data) {
      if (this.isNew) {
        this.dataList.push(data)
      } else {
        let i = 0
        while (i < this.dataList.length) {
          if (this.dataList[i].key === data.key) {
            this.dataList[i] = data
          }
          i += 1
        }
      }
      this.$emit('change', this.dataList.map((v) => {
        let a = {}
        Object.keys(v).forEach((v2) => {
          a[v2] = v[v2]
        })
        return a
      }))
      this.openDialog = false
    },
    conf () {
      this.openDialog = true
    }
  }
}
</script>

<style lang="less" scoped>
.f-p {
  align-items: center;
  margin-left: 1rem;
  width: calc(100% - 1rem);
  .f-p-data {
    border: 1px solid #dcdee2;
    border-top: 0px;
    height: 10rem;
    width: calc(100% - 1rem);
  }
}
</style>
